import { LicenseModule } from "./LicenseModule";
import { LicenseModuleEnum } from "./LicenseModuleEnum";
import { LicenseModuleStatusEnum } from "./LicenseModuleStatusEnum";

export class LicenseData {
    isHardwareKey: boolean;
    maxDevices: number;
    toUpdateDeviceLicenseExpiration: boolean;
    oemCodes: string[] = [];
    modules: LicenseModule[] = [];

    isAvailable(module: LicenseModuleEnum): boolean {
        if (module == LicenseModuleEnum.None) return true;

        var mod = this.modules.find((l) => (l.module & module) == l.module);
        if (mod) {
            return mod.isAvailable();
        }

        return false;
    }

    areAllExpirationDatesTheSame(): boolean {
        var res: boolean = true;
        var currentDate: Date = null;
        this.modules.forEach((module) => {
            if (currentDate == null) currentDate = module.expirationDate;
            else if (module.expirationDate.toLocaleDateString() != currentDate.toLocaleDateString()) res = false;
        });
        return res;
    }
}
